import type { ToastListItem } from '../types'

export const toastsReducer = (
  state: { list: ToastListItem[] },
  action: { type: 'add' | 'remove'; toast: ToastListItem },
) => {
  switch (action.type) {
    case 'add': {
      const exists = state.list.some(t => t.id === action.toast.id)
      if (exists) {
        return { list: state.list.map(t => (t.id === action.toast.id ? action.toast : t)) }
      }
      return { list: [action.toast, ...state.list].slice(0, 3) }
    }
    case 'remove': {
      return { list: state.list.filter(t => t.id !== action.toast.id) }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

export const genericReducer = (state: any, action: any) => (state = action)
